import { BaseConfig } from "../config.interface";

interface IFileUploadPickerConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Determine the maximum amount of uploaded files.
     * Use -1 for unlimited.
     */
    uploadLimit?: number;
    /**
     * File size limit for each file in MB.
     */
    fileSizeLimit?: number;
    /**
     * MIME types of the accepted files.
     */
    acceptedFileTypes: string;
}


export class FileUploadPickerConfig extends BaseConfig<IFileUploadPickerConfig> implements IFileUploadPickerConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Determine the maximum amount of uploaded files.
     * Use -1 for unlimited.
     */
    uploadLimit?: number;
    /**
     * File size limit for each file in bytes.
     */
    fileSizeLimit?: number;
    /**
     * MIME types of the accepted files.
     */
    acceptedFileTypes: string;

    /**
     * @theme Base
     */
    static baseTheme = {
        Default: new FileUploadPickerConfig({
            acceptedFileTypes: '',
            uploadLimit:       1,
            fileSizeLimit:     100,
        }),
        Images: new FileUploadPickerConfig({
            acceptedFileTypes: 'image/jpg, image/jpeg, image/png, image/svg, image/gif',
            uploadLimit:       -1,
            fileSizeLimit:     100,
        }),
        Image: new FileUploadPickerConfig({
            acceptedFileTypes: 'image/jpg, image/jpeg, image/png, image/svg, image/gif',
            uploadLimit:       1,
            fileSizeLimit:     100,
        }),
        ImagesAndVideos: new FileUploadPickerConfig({
            acceptedFileTypes: [
                'image/webp, image/jpg, image/jpeg, image/png, image/svg, image/gif',
                'video/mp4, video/webm'
            ].join(', '),
            uploadLimit:   -1,
            fileSizeLimit: 500,
        }),
        /**
         * Scans/photos of paper documents (e.g. Auszeit-Nachweis).
         * Restricted to what the FileBridgeWorker serves back: JPEG, PNG and PDF.
         */
        Document: new FileUploadPickerConfig({
            acceptedFileTypes: 'image/jpg, image/jpeg, image/png, application/pdf',
            uploadLimit:       1,
            fileSizeLimit:     20,
        }),
        Documents: new FileUploadPickerConfig({
            acceptedFileTypes: 'image/jpg, image/jpeg, image/png, application/pdf',
            uploadLimit:       -1,
            fileSizeLimit:     20,
        }),
    };

}
